import React, { Component } from "react";
import PendingForm from "../PendingForm/PendingForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : VacationPage
Description : Compoente que alberga el formulario de Vacation definido en el directorio de componentes
Date Autor Modification
================================================================================
29/09/2022 Santiago Coca - Se define el componente
================================================================================ */

class PendingPage extends Component {
    render() {
        return (
            <div>
                <PendingForm />
            </div>
        )
    }
}

export default PendingPage;